"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var base_condition_1 = require("./base.condition");
var models_1 = require("../../models");
var SkillAvailableCondition = /** @class */ (function (_super) {
    __extends(SkillAvailableCondition, _super);
    function SkillAvailableCondition(options, skillService, notificationService) {
        var _this = _super.call(this, "SkillAvailableCondition", notificationService) || this;
        _this.skillService = skillService;
        _this.observable = new Observable_1.Observable(function (observer) {
            _this.skillService.getSkillStatus([options.DefaultSkillAddressName]).subscribe(function (skill) {
                console.log("fetched " + skill.length + " item(s) for '" + options.DefaultSkillAddressName + "' skill");
                if (options.AgentAvailability.MaxWaitTimeSeconds && skill[0].WaitTimeSeconds > options.AgentAvailability.MaxWaitTimeSeconds) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " wait time is too long");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.MinAgentCapacity && skill[0].AvailableCapacity && skill[0].AvailableCapacity < options.AgentAvailability.MinAgentCapacity) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " does not have enough agent capacity");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.MinActiveAgents && skill[0].ActiveUsers < options.AgentAvailability.MinActiveAgents) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " does not have enough active agents");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.WithinBusinessHour && (skill[0].WithinBusinessHour !== options.AgentAvailability.WithinBusinessHour)) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " have no agent within Business hours");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.MinCloseTimeInSeconds && skill[0].CloseInSeconds && skill[0].CloseInSeconds < options.AgentAvailability.MinCloseTimeInSeconds) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " will be closing soon");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.MinCapacityPercentage && skill[0].CapacityPercentage && skill[0].CapacityPercentage < options.AgentAvailability.MinCapacityPercentage) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " does not have enough capacity percentage");
                    observer.next(false);
                    return;
                }
                if (options.AgentAvailability.Status && (skill[0].Status !== options.AgentAvailability.Status.toLowerCase())) {
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, options.DefaultSkillAddressName + " status not matched");
                    observer.next(false);
                    return;
                }
                console.log("Checking Skill availability for skill '" + options.DefaultSkillAddressName + "' passed");
                observer.next(true);
            }, function (err) {
                _this.onConditionFail(models_1.ConditionFailReason.ServerError, "Failed to get skill status due to error " + err);
                observer.next(false);
            });
        });
        return _this;
    }
    return SkillAvailableCondition;
}(base_condition_1.BaseCondition));
exports.SkillAvailableCondition = SkillAvailableCondition;
